import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfigService ,ApiConfig} from './config.service';
import { CurriculumSearchRequest } from '../search/curriculum/curriculum';

@Injectable({
  providedIn: 'root'
})
export class CurriculumService {
  //private baseUrl = `${environment.apiUrlCurriculum}`;
  private _apiconfig: ApiConfig;
  private apiUrl = '';
  private token = '';

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
   ) { 
    this._apiconfig =  this.configService.apiConfig;
    this.apiUrl = this._apiconfig.url;
    this.token = this._apiconfig.token;
   }


  handleError(error: HttpErrorResponse): Observable<never> {
      return throwError(() => new Error(error.message));
  }

  //GetCurriculumFlag   Flag: boolean true/false
  public GetCurriculumFlag(): Observable<any>{
      return this.http.get<any>(`${this.apiUrl}/api/GetCurriculumFlag`, {
        headers: new HttpHeaders()
        .set('Content-Type','application/json'),
        observe: 'response'
      }).pipe(catchError(this.handleError));
  }

  //GetFacultyList
  public GetFacultyList(): Observable<any>{
      return this.http.get<any>(`${this.apiUrl}/api/GetFacultyList`, {
        headers: new HttpHeaders()
        .set('Content-Type','application/json'),
        observe: 'response'
      }
      ).pipe(catchError(this.handleError));
  }

  //GetCurriculumInfo
  public GetCurriculumInfo(facultyId: string): Observable<any>{
      return this.http.get<any>(`${this.apiUrl}/api/GetCurriculumInfo/${facultyId}`, {
        headers: new HttpHeaders()
        .set('Content-Type','application/json'),
        observe: 'response'
      }).pipe(catchError(this.handleError));
  }


  //GetCurriculumCount
  public GetCurriculumCount(request: CurriculumSearchRequest): Observable<any>{
    return this.http.post<any>(`${this.apiUrl}/api/GetCurriculumCount`, request, {
      headers: new HttpHeaders()
      .set('Content-Type','application/json'),
      observe: 'response'
    }).pipe(catchError(this.handleError));
  }
}
